import { IS_APP } from "@/__main__/constants.mjs";
import globals from "@/util/global-whitelist.mjs";

// XXX: is there any security concern?
export function inject(url) {
  return new Promise((resolve, reject) => {
    const script = globals.document?.createElement("script");
    // To make sure it works in SSR as well
    if (!script || !url) {
      resolve(null);
      return;
    }
    script.src = url;
    script.async = true;
    script.addEventListener("load", eventScriptLoaded);
    script.addEventListener("error", eventScriptError);
    globals.document?.body.appendChild(script);

    function eventScriptLoaded() {
      eventFinally();
      resolve(script);
    }

    function eventScriptError() {
      eventFinally();
      reject(new Error(`LOAD ANALYTICS SCRIPT ERROR: ${url}`));
    }

    function eventFinally() {
      script.removeEventListener("load", eventScriptLoaded);
      script.removeEventListener("error", eventScriptLoaded);
    }
  });
}

/*
  interface IProvider {
    name, url: string;
    web, app: boolean;
    initialize, finalize: () => {},
    promise: Promise<HTMLScriptElement>,
    script: HTMLScriptElement,
  }
*/

function isEnabled(provider) {
  if (IS_APP) {
    return provider.app;
  }
  return provider.web;
}

export function initializeProviders(providers) {
  for (const p of providers) {
    if (!isEnabled(p)) continue;
    if (typeof p.initialize === "function") {
      p.initialize();
    }
    p.promise = inject(p.url);
    p.promise.then(
      (scriptElem) => {
        p.script = scriptElem;
      },
      (err) => {
        p.error = err || true;
      },
    );
  }
  return Promise.all(providers.map((p) => p.promise));
}

export function finalizeProviders(providers) {
  return Promise.all(
    providers.map(
      (p) =>
        new Promise((resolve) => {
          if (!isEnabled(p)) {
            resolve();
            return;
          }
          // no matter <script> status, we did initialize() before
          // do paired finalize()
          if (typeof p.finalize === "function") {
            p.finalize();
          }
          const promise = p.promise;
          p.promise = null;
          promise.then(
            () => {
              // if <script> loaded
              const node = p.script;
              p.script = null;
              if (!node || !node.parentNode) {
                resolve();
                return;
              }
              node.remove();
              resolve();
            },
            () => {
              // if <script> failed
              p.error = null;
              resolve();
            },
          );
        }),
    ),
  );
}
